export default "__VITE_ASSET__C0ial0aJ__"